import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateProgram = (props) => {
  return (
    <Create
// @ts-ignore
      title='Create Program'
      fields={fields}
      apiPath='admin/programs'
      successRedirectPath={resource => `/write-now/programs/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateProgram
